import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	learnMore: {
		id: 'business-calendar.calendar-view.calendar-release-for-multiple-projects.learn-more-item.learn-more',
		defaultMessage: 'Learn more',
		description:
			'The dropdown option text of linking to a information page to learn more about releases',
	},
});
